import { Select } from './gb-select';
riot.tag2('gb-option', '<a onclick="{send}">{label}</a>', '', '', function(opts) {
    this.label = Select.optionLabel(opts.option);
    this.value = Select.optionValue(opts.option);
    this.send = () => opts.send(this);
});



/** WEBPACK FOOTER **
 ** ./src/tags/select/gb-option.tag.html
 **/